import type { FaireProductEntity } from "../../entity_types/product";

export const p_prguw9vwjy: FaireProductEntity = {
  token: "p_prguw9vwjy",
  type: "product",
  name: "Chupa Chups Sparkling Cherry Bubble Gum Soda (Can) 345ml (Chupa Chups)",
  brandToken: "b_vsezuurgak",
  brandName: "Made in eatalia",
  imageUrl:
    "https://cdn.faire.com/fastly/37617f42b1d36009e767994d62849bed484847f4fb1894ac1a3486653483ec60.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.98,
  description:
    "\nChupa Chups Sparkling Cherry Bubble Gum Soda (Can) 345ml (Chupa Chups)\n\nChupa Chups Cherry Bubble Gum Soda is a fizzy, sweet drink that’s bursting with juicy cherry bubble gum flavor. It offers a taste of summer in a refreshing beverage that’s perfect for hot days, parties, or anytime you want a fruity treat.\n",
  tags: [],
  msrpDollars: 3.73,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:29.623Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
